import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useSearchParams } from "react-router-dom";
import { loadGuest } from '../../actions/auth';
import { getMyConferenceBooking } from '../../actions/conference';

const ConferencePaymentSuccess = ({loadGuest, getMyConferenceBooking}) => {

useEffect(()=>{
    loadGuest();
    },[loadGuest]);
  
  useEffect(()=>{
    getMyConferenceBooking();
  },[getMyConferenceBooking]);

  const searchQuery = useSearchParams()[0];
  const referenceNum = searchQuery.get("reference");
  return (
    <div className='container' style={{ "alignItems":"center", "justifyContent": "center", "textAlign": "center" }}>
    <h1 className='large' style={{ "color": "#28a745"}}> Payment Successful</h1>
    <p className='text text-primary lead'> Payment Reference Number: {referenceNum } </p>
    <button className='btn btn-light' style={{"margin": "20px"}}><Link to='/conferencebookings'> Go back </Link></button>
    {/* <button onClick={() => window.location.reload()}>Refresh</button> */}
    </div>
  )
}

ConferencePaymentSuccess.propTypes = {
  loadGuest: propTypes.func.isRequired,
  getMyConferenceBooking: propTypes.func.isRequired,
};

export default connect(null, {loadGuest, getMyConferenceBooking})(ConferencePaymentSuccess);